import theme from "../../../Theme/Theme";
import phaseIcon from "./../../../Assets/Icons/phase_sm.svg";
import groupAssignmentIcon from "./../../../Assets/Icons/e4h/group_assignment_sm.svg";
import workshopIcon from "./../../../Assets/Icons/e4h/workshop_sm.svg";
import discussionIcon from "./../../../Assets/Icons/e4h/discussion_sm.svg";
import assignmentIcon from "./../../../Assets/Icons/e4h/assignment_sm.svg";

const primary = theme.colors.primary;
const dark = theme.colors.dark;
const society = theme.colors.society;
const community = theme.colors.community;
const student = theme.colors.student;
const phase = '#739D63' + '59';
const gray = '#f3f3f3';

const dot = (color, name) => ({
  // alignItems: 'center',
  // display: 'flex',
  // flexWrap: 'wrap',
  ':before': {
    backgroundColor: color === phase || color === primary ? null : color,
    borderRadius: color === primary ? null : 12,
    content: color ? '" "' : null,
    display: 'inline-block',
    marginRight: 8,
    marginBottom: name === 'Workshop / Lab'? -8 : name === 'Stimulus / Discussion' ? -5 : name === 'Individual Assignment' ? -6 : -1,
    height: name === 'Workshop / Lab'? 24 : name === 'Stimulus / Discussion' ? 20 : name === 'Individual Assignment' ? 21 : 12,
    width: name === 'Group Assignment' ? 26 : name === 'Workshop / Lab'? 5 : name === 'Stimulus / Discussion' ? 20 : name === 'Individual Assignment' ? 16 : 12,
    backgroundImage: color === phase ?
      `url(${phaseIcon})` :
      name === 'Group Assignment' ?
        `url(${groupAssignmentIcon})` :
        name === 'Workshop / Lab' ?
          `url(${workshopIcon})` :
          name === 'Stimulus / Discussion' ?
            `url(${discussionIcon})` :
            name === 'Individual Assignment' ?
              `url(${assignmentIcon})` : null
  },
});

const specialColors = (name, color) => {
  if (name === 'Society') {
    return society
  }
  if (name === 'Community partner') {
    return community
  }
  if (name === 'Student, Team, Class') {
    return student
  }
  if (name === "Who's our partner?" || name === "What's our project?" || name === "What's our product?") {
    return phase
  }
  else return color
};

const selectStyles = {
  control: (styles, {isFocused} )=> ({
    ...styles,
    backgroundColor: 'white',
    boxShadow: isFocused ? '0 0 0 1px ' + primary : null,
    ':hover': {
      ...styles[':hover'],
      borderColor: primary
    },
    minHeight: '40px'
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
          ? specialColors(data.label, primary)
          : isFocused
            ? specialColors(data.label, primary)
            : null,
      color: specialColors(data.label, primary) !== phase ?
        isSelected
        ? 'white'
        : isFocused
          ? 'white' :
          dark : dark,
      cursor: isDisabled ? 'not-allowed' : 'default',
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? primary : 'white'),
      },
    };
  },
  multiValue: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: gray,
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: dark,
    ...dot(specialColors(data.label, primary), data.label)
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: dark,
    ':hover': {
      backgroundColor: specialColors(data.label, primary),
      color: specialColors(data.label, primary) !== phase ? 'white' : dark,
    },
    ':focus': {
      backgroundColor: specialColors(data.label, primary),
      color: specialColors(data.label, primary) !== phase ? 'white' : dark,
    },
  }),
};

export { selectStyles }
